'use client'

import { Pod4FAQ } from 'components/Pod4FAQ'
import { Pod4FAQProps } from 'components/Pod4FAQ/types'
import { FC } from 'react'
import { useIsMember } from 'stores/promo'
import { useCurrentRegion } from 'stores/settings'
import { passesFilter } from 'utils/sanity'

export const FinancingFAQs: FC<{ faqData: Pod4FAQProps }> = ({ faqData }) => {
	const currentRegion = useCurrentRegion()
	const isMember = useIsMember()

	const filteredFAQData = faqData.faq.filter((faq) => passesFilter(currentRegion, isMember, faq.filters))

	return <Pod4FAQ faq={filteredFAQData} />
}
